import React from 'react';
import { OAuthProvider } from 'firebase/auth';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { saveUserSession } from '../../../redux/actions/userActions';
import { useOAuthSignIn } from '../../../utils/Hooks/useOAuthSignIn';
import { AuthButton } from './AppleAuth.styles';
import { AppleIcon } from '../../../assets/images';

const AppleSignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const provider = new OAuthProvider('apple.com');
  provider.addScope('email');
  provider.addScope('name');

  const { signIn, isSigningIn } = useOAuthSignIn(provider);

  const handleAppleSignIn = async () => {
    try {
      const user = await signIn();
      dispatch(saveUserSession(user, 'apple'));
      navigate("/onboarding");
    } catch (error) {
      console.error('Apple Sign-In failed:', error);
    }
  };

  return (
    <AuthButton
      onClick={handleAppleSignIn}
      startIcon={<AppleIcon />}
      variant="contained"
      color="inherit"
      disabled={isSigningIn}
    >
      {isSigningIn ? 'Signing in...' : 'Sign In with Apple'}
    </AuthButton>
  );
};

export default AppleSignIn;